import { ACTION_TYPES } from './actions';

const initialState = [];

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.ADD_PROFILE_TO_FAVOURITES: {
      const index = (state || []).findIndex(
        ({ id }) => id === action.payload.id
      );
      // Don't re-add the profile if it already exists and has the removed property, just changed the removed status to false
      if (index !== -1 && state[index].removed) {
        return state.map(profile => {
          if (profile.id === action.payload.id)
            return { ...profile, removed: false };
          return profile;
        });
      }
      if (index === -1) {
        return [...state, action.payload];
      }
      return state;
    }
    case ACTION_TYPES.REMOVE_PROFILE_FROM_FAVOURITES: {
      if (!state.length) return state;
      return state.filter(({ id }) => id !== action.payload);
    }
    case ACTION_TYPES.SET_FAVOURITES: {
      return action.payload;
    }
    case ACTION_TYPES.SET_REMOVED_STATUS: {
      if (!state.length) return state;
      return state.map(profile => {
        if (profile.id === action.payload) return { ...profile, removed: true };
        return profile;
      });
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

export { initialState };
export default reducer;
